export const documentTypesOptions = [
    {value: "BLINDILPN", label: "Blind ILPN"},
    {value: "BGRADE", label: "Bgrade"},
    {value: "BOL_REPORT", label: "BOL Report"},
    {value: "CARRIER_LABEL", label: "Carrier Label"},
    {value: "CGRADE", label: "Cgrade"},
    {value: "COLLATE_REPORT", label: "Collate Report"},
    {value: "CMR", label: "CMR"},
    {value: "ENDSPUR", label: "End spur"},
    {value: "UPCRFID", label: "UPC RFID Label"},
    {value: "GENERIC_ZPL", label: "Generic ZPL"},
    {value: "GIFT_CARD", label: "Gift Card"},
    {value: "ILPN", label: "ILPN"},
    {value: "INTERNAL_CARRIER_LABEL", label: "Internal Carrier Label"},
    {value: "INVOICE", label: "Invoice"},
    {value: "LPN_LABEL", label: "LPN Label"},
    {value: "NDS_VAS", label: "NDS VAS Label"},
    {value: "NIKE_LABEL", label: "Nike Label"},
    {value: "OLPN_CONTENT_LABEL", label: "OLPN Content Label"},
    {value: "PACKLIST", label: "Pack list"},
    {value: "PACKLIST_PRODUCT", label: "Pack list (product)"},
    {value: "PACKLIST_CARTON", label: "Pack list (carton)"},
    {value: "PALLET", label: "Pallet Label"},
    {value: "OFFSITE_PALLET", label: "Offsite Pallet Label"},
    {value: "PICKCARTON", label: "Pick carton"},
    {value: "RETURN_LABEL", label: "Return Label"},
    {value: "SCANLOAD", label: "Scanload Document"},
    {value: "SHOEBOX_LABEL", label: "Shoebox Label"},
    {value: "SHIPPING_LABEL", label: "Shipping Label"},
    {value: "STARTSPUR", label: "Start spur"},
    {value: "TASK_LABEL", label: "Task Label"},
    {value: "TASKSTART", label: "Task start"},
    {value: "TASKSTARTV2", label: "Task start v2 - impact"},
    {value: "TASKSTARTV3", label: "Task start v3"},
    {value: "UNIT", label: "Unit Label"},
    {value: "UPC_LABEL", label: "Upc Label"},
    {value: "MANIFEST", label: "Manifest"},
    {value: "CARTON1093", label: "Carton1093"},
];

export function mapDocumentType(documentType: string): string {
    const matchingOption = documentTypesOptions.find((option) => option.value === documentType);
    return matchingOption ? matchingOption.label : documentType
}
